const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

/** Human-readable file size, one decimal place above bytes: "512 B", "1.5 KB", "20.0 MB". */
export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1);
  if (exponent === 0) return `${Math.round(bytes)} B`;
  return `${(bytes / Math.pow(1024, exponent)).toFixed(1)} ${UNITS[exponent]}`;
}
